var brandInfoAll={
  bannerInfo:{
    bannerNmae:"阿童木机器人",
    createTime:"2013年",
    area:"中国 天津",
    honor:[
      '高新技术企业',
      '天津市技术领先型企业',
      '天津市瞪羚企业'
    ],
  },
  subsidiary:[
    {
      name:"天津",
      langname:"天津（总公司）",
      address:"天津滨海新区泰达智能无人装备产业园29号",
      corporateName:"天津辰星技术股份有限公司"
    },
    {
      name:"苏州吴江",
      langname:"苏州吴江",
      address:"江苏省苏州市吴江经济技术开发区联杨路139号",
      corporateName:"辰星（苏州）自动化设备有限公司"
    },
    {
      name:"苏州昆山",
      langname:"苏州昆山",
      address:"昆山市张浦镇振新东路浩盛工业园 C-6",
      corporateName:"江苏小野智能装备有限公司"
    },
    {
      name:"深圳",
      langname:"深圳",
      address:"深圳宝安区西乡街道华丰机 器人产业园F611",
      corporateName:"深圳小百自动化科技有限公司"
    },
    {
      name:"成都",
      langname:"成都（子公司）",
      address:"成都市郫都区现代工业港北片区蜀新大道306号 汇创天下科技园",
      corporateName:"天津辰星技术股份有限公司"
    },
  ],
  productsTitle:"/static/brand/advantage.png",
  characteristic:[
      {
          'titleImg':"/static/brand/advantage1.png",
          'title':"高速度",
          'list':[
              "国际标准测试轨迹（25-305-25）下，节拍最高可稳定在600次/min",
              "单台机器人可节约人工3-5人，替代2-4台传统分拣设备"
          ]
      },
      {
          'titleImg':"/static/brand/advantage2.png",
          'title':"高精度",
          'list':[
              "即使在高速（300次/min以上）条件下重复定位精度依旧可达±0.02mm",
              "更适合高速（200次/min以上）状态下的，高精度（±0.05mm）以内的分拣、装配作业"
          ]
      },
      {
          'titleImg':"/static/brand/advantage3.png",
          'title':"高稳定性",
          'list':[
              "本体全年免维护，各关节无需额外润滑保养，预紧结构终身无间隙",
              "结构设计简约，装备连接可靠，核心零部件均来自顶级供应商，使用寿命长达8年"
          ]
      }
  ],
  certify:[
     
  ],

  servicesTitle:"/static/brand/service.png",
  services:[
    {
        'titleImg':"/static/brand/service1.png",
        'title':"极速响应",
        'info':"及时响应，快速解决问题是我们始终坚持的售后服务追求。"
    },
    {
        'titleImg':"/static/brand/service2.png",
        'title':"备件充足",
        'info':"公司拥有充足的备件库存、先进的仓储管理系统，及时快速的配送体系，以免除客户的售后之忧。"
    }, 
    {
        'titleImg':"/static/brand/service3.png",
        'title':"五大服务中心",
        'info':"天津、苏州、昆山、深圳、成都五大服务中心为客户提供完善的服务网络，时刻保持与客户的紧密沟通，确保我们出售的每套机器人系统都能长期稳定地运行。"
    },
    {
        'titleImg':"/static/brand/service4.png",
        'title':"实时远程运维",
        'info':"天津公司已为我们最新的机器人系统安装物联网模块，设备一旦出现故障，云端大数据将进行预警，我们的技术工程师可远程实时诊断及修复。"
    }
  ],

  industryTitle:"/static/brand/Vector.png",
  industrylist:[
      {
        name:"制药行业",
        info:[
            '颗粒袋装盒流水线',
            'BFS分拣装盒',
            '西林瓶装盒单元'
        ],
        icon:"/static/brand/icon/zy.png",
        onicon:"/static/brand/onicon/zy.png",
        bjimg:"/static/brand/bj/zy.jpg"
      },
      {
        name:"乳品饮料行业",
        info:[
            '杯装奶装筐工作站',
            '杯装奶入托',
            '利乐枕装箱',
            '冰淇淋装箱'
        ],
        icon:"/static/brand/icon/rp.png",
        onicon:"/static/brand/onicon/rp.png",
        bjimg:"/static/brand/bj/rp.jpg"
      },
      {
        name:"日化行业",
        info:[
            '香水瓶盖分拣入托单元',
            '洗发水空瓶分拣入罐装机单元',
            '洗洁精瓶分拣入槽单元',
            '化妆品瓶子分拣入槽',
            '湿巾装盖',
        ],
        icon:"/static/brand/icon/rh.png",
        onicon:"/static/brand/onicon/rh.png",
        bjimg:"/static/brand/bj/rh.jpg"
      },
      {
        name:"3C行业",
        info:[
            '半导体芯片摆盘',
            'AOI上下料检测',
            '手机中板入篮',
            '电磁炉发热器件装配',
        ],
        icon:"/static/brand/icon/3C.png",
        onicon:"/static/brand/onicon/3C.png",
        bjimg:"/static/brand/bj/3C.jpg"
      },
      {
        name:"PCB行业",
        info:[
            'PCB板收板叠片工作站',
            'PCB板入清洗机工作站'
        ],
        icon:"/static/brand/icon/PCB.png",
        onicon:"/static/brand/onicon/PCB.png",
        bjimg:"/static/brand/bj/PCB.jpg"
      },
      {
        name:"新能源行业",
        info:[
            '柱状电池分拣工作站',
            '新能源电池极片分拣工作站',
            '电池铝壳分拣插花篮',
            '太阳能电池片入花篮'
        ],
        icon:"/static/brand/icon/xny.png",
        onicon:"/static/brand/onicon/xny.png",
        bjimg:"/static/brand/bj/xny.jpg"
      },
      {
        name:"食品行业",
        info:[
            '袋装粉剂装箱',
            '榨菜装箱',
            '休闲食品装托自动化方案',
            '火腿肠入拉伸膜包装机'
        ],
        icon:"/static/brand/icon/sp.png",
        onicon:"/static/brand/onicon/sp.png",
        bjimg:"/static/brand/bj/sp.jpg"
      },
      {
        name:"汽车及零部件行业",
        info:[
            '汽车轮毂放堵头工作站',
            '汽车仪表台插卡扣工作站',
            '发动机油底壳插销工作站',
            '汽车玻璃高精搬运单元',
            '汽车垫片收片工作站',
            '汽车零部件入研磨机',
        ],
        icon:"/static/brand/icon/car.png",
        onicon:"/static/brand/onicon/car.png",
        bjimg:"/static/brand/bj/car.jpg"
      },
  ],
  //关于我们
  aboutus:
  {
        info:"阿童木机器人作为工业机器人领域知名厂商，以“用技术解放双手”为使命，致力于为食品、制药、日化、3C、PCB、新能源等细分行业集成商客户提供单机和工作站，帮助客户降本增效。公司始终坚持自主正向研发，先后推出全自主知识产权的D2、D3、D4、D5、S6全系列并联机器人，SH800高速scara机器人，PM系列装箱工作站以及全自主控制器等产品，是软硬件一体化的机器人科技公司。秉承“专心、创新、匠心”的品牌精神，向全球最值得信赖的工业机器人服务商迈进。截至目前，公司业务遍布全球20多个国家，累计服务超500家规模级企业客户，出货量超3000台（套）。公司总部位于天津市滨海新区，并在江苏苏州、昆山、南京、广东深圳等地设有子公司。",
        video:"https://image.sjyuan.net.cn/video/mvb/1656118573039862.mp4",
        poster:"/static/brand/video.jpg",
        aboutTitle:"/static/brand/kehudiyi.png",
        aboutTitleWidth:"420px"
  },
  metaInfo:{
    title:"阿童木机器人_Movibot品牌_工业机器人-并联机器人",
    keywords:"工业机器人_并联机器人_scara机器人_阿童木机器人",
    description:"阿童木机器人是中国知名并联机器人,scara机器人服务商，MOVIBOT为您提供品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/1.js